import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import './wave.css';
import React from 'react';
import { clsx } from '../utils';

var Wave = function Wave(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      style = _ref.style,
      thickness = _ref.thickness;

  var varStyle = _objectSpread({}, style);

  color && (varStyle['--rcs-wave-color'] = color);
  size && (varStyle['--rcs-wave-size'] = "".concat(size, "px"));
  thickness && (varStyle['--rcs-wave-thickness'] = "".concat(thickness, "px"));
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('rcs-wave', className),
    style: varStyle
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null));
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Wave;